import Image from 'next/image';

import { Heading, Page, Paragraph } from '@zillow/constellation-10';

import { FOR_SALE_ILLUSTRATION_URL } from '../../constants/DigitalLibraryConstants';

type LoadingStateVariant = 'default' | 'newProperty' | 'zram';

const COPY: Record<LoadingStateVariant, { heading: string; subheading: string }> = {
  default: {
    heading: 'Picking up where you left off',
    subheading: 'One moment while we load your progress.',
  },
  newProperty: {
    heading: 'Setting up your listing',
    subheading: 'One moment while we get things ready.',
  },
  zram: {
    heading: 'Loading your property',
    subheading: 'This should only take a moment.',
  },
};

export const CLPLoadingState = ({
  isNewProperty = false,
  isZram = false,
}: {
  isNewProperty?: boolean;
  isZram?: boolean;
}) => {
  const variant: LoadingStateVariant = isZram ? 'zram' : isNewProperty ? 'newProperty' : 'default';
  const { heading, subheading } = COPY[variant];

  return (
    <Page.Root
      css={{
        height: '100vh',
        backgroundColor: 'bg.neutral',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Image priority width={120} height={120} src={FOR_SALE_ILLUSTRATION_URL} alt="" role="presentation" />
      <Heading level={1} textStyle="heading-sm">
        {heading}
      </Heading>
      <Paragraph textStyle="body-sm">{subheading}</Paragraph>
    </Page.Root>
  );
};
